module.exports = " <footer> <ul> <li> <a href=http://xyxiao001.github.io target=_blank>博客</a> <a href=https://pixabay.com target=_blank>pixabay</a> <a href=https://github.com/xyxiao001 target=_blank>github</a> @2016&nbsp;好男孩 </li> </ul> </footer> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
 ** module id = 69
 ** module chunks = 0
 **/